import createSvgIcon from "./utils/create_icon"

const MinusLarge = createSvgIcon(<path d="M6 11a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z" fill="currentColor" />, "MinusLarge")
export default MinusLarge
